<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="credentials-container">
  <div class="col-12">
    <div class="dashboard-header">
      <div class="header-content">
        <div class="header-title-section">
          <h1><i class="pi pi-shield"></i> Credentials Assureurs Santé</h1>
          <p class="dashboard-subtitle">{{ getTotalCredentials() }} credential(s) configurée(s) &middot; {{ getTotalUsers() }} utilisateur(s)</p>
        </div>
        <div class="header-actions">
          <p-button 
            icon="pi pi-refresh" 
            (onClick)="loadCredentials()"
            [disabled]="loading"
            [loading]="loading"
            styleClass="p-button-outlined p-button-secondary"
            pTooltip="Actualiser"
            tooltipPosition="bottom">
          </p-button>
          <p-button *ngIf="isAdmin" label="Seed Data" icon="pi pi-database" (onClick)="seedCredentials()" severity="info" [outlined]="true" [loading]="loading"></p-button>
          <p-button *ngIf="isAdmin" label="Ajouter" icon="pi pi-plus" (onClick)="openAddDialog()" severity="success"></p-button>
        </div>
      </div>
    </div>

    <div class="table-container">

  <!-- Grouped by user -->
  <div *ngIf="!loading; else loadingBlock">
    <div *ngIf="groupedByUser.length === 0" class="empty-state">
      <i class="pi pi-inbox" style="font-size: 3rem; color: #ccc;"></i>
      <p>Aucun credential configuré. Cliquez sur "Ajouter" pour commencer.</p>
    </div>

      <div class="grouped-view">
        <p-accordion>
          <p-accordionTab *ngFor="let group of groupedByUser">
            <ng-template pTemplate="header">
              <div class="accordion-header-content">
                <div class="user-info-header">
                  <div class="user-avatar-cred">
                    {{ (group.userName || '').charAt(0).toUpperCase() || 'U' }}
                  </div>
                  <div class="user-meta">
                    <span class="user-name-cred">{{ group.userName }}</span>
                    <span class="user-email-cred">{{ group.userEmail }}</span>
                  </div>
                  <p-tag [value]="group.credentials.length + ' assureur(s)'" 
                         severity="info" [rounded]="true" class="count-badge"></p-tag>
                </div>
              </div>
            </ng-template>

            <div class="credential-table-wrapper">
              <p-table [value]="group.credentials" [rows]="20" [responsive]="true" styleClass="p-datatable-sm p-datatable-striped">
        <ng-template pTemplate="header">
          <tr>
            <th>Assureur</th>
            <th>Login</th>
            <th>Mot de passe</th>
            <th>Code courtier</th>
            <th *ngIf="isAdmin" style="width: 120px">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-cred>
          <tr>
            <td>
              <p-tag [value]="cred.assureurDisplayName" [severity]="getAssureurSeverity(cred.assureurName)"></p-tag>
            </td>
            <td>
              <code>{{ cred.login }}</code>
            </td>
            <td>
              <span *ngIf="!isPasswordVisible(cred.id)" class="password-masked"
                    (click)="togglePassword(cred.id)" pTooltip="Cliquer pour afficher">
                {{ maskPassword(cred.password) }}
                <i class="pi pi-eye ml-1" style="cursor: pointer;"></i>
              </span>
              <span *ngIf="isPasswordVisible(cred.id)" class="password-visible"
                    (click)="togglePassword(cred.id)" pTooltip="Cliquer pour masquer">
                <code>{{ cred.password }}</code>
                <i class="pi pi-eye-slash ml-1" style="cursor: pointer;"></i>
              </span>
            </td>
            <td>
              <code *ngIf="cred.codeCourtier">{{ cred.codeCourtier }}</code>
              <span *ngIf="!cred.codeCourtier" class="text-400">-</span>
            </td>
            <td *ngIf="isAdmin">
              <p-button icon="pi pi-pencil" [rounded]="true" severity="info" [text]="true"
                        pTooltip="Modifier" (onClick)="openEditDialog(cred)"></p-button>
              <p-button icon="pi pi-trash" [rounded]="true" severity="danger" [text]="true"
                        pTooltip="Supprimer" (onClick)="onDelete(cred)"></p-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td [attr.colspan]="isAdmin ? 5 : 4" class="text-center">Aucun credential pour cet utilisateur</td></tr>
        </ng-template>
              </p-table>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>
  </div>

  <ng-template #loadingBlock>
    <div class="loading-state">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
      <p>Chargement des credentials...</p>
    </div>
  </ng-template>
</div>

<!-- Dialog Ajout -->
<p-dialog *ngIf="isAdmin" header="Ajouter un credential santé" [(visible)]="showAddDialog" [modal]="true"
          [style]="{width: '500px'}" [closable]="true">
  <form [formGroup]="addForm" (ngSubmit)="onAdd()">
    <div class="field mb-3">
      <label for="userId" class="block mb-1 font-semibold">Utilisateur *</label>
      <p-dropdown formControlName="userId" [options]="userOptions" placeholder="Sélectionner un utilisateur"
                  [filter]="true" filterBy="label" [style]="{width: '100%'}"></p-dropdown>
    </div>
    <div class="field mb-3">
      <label for="assureurName" class="block mb-1 font-semibold">Assureur *</label>
      <p-dropdown formControlName="assureurName" [options]="assureurOptions" placeholder="Sélectionner un assureur"
                  [filter]="true" filterBy="label" [style]="{width: '100%'}"></p-dropdown>
    </div>
    <div class="field mb-3">
      <label for="login" class="block mb-1 font-semibold">Login *</label>
      <input pInputText formControlName="login" class="w-full" />
    </div>
    <div class="field mb-3">
      <label for="password" class="block mb-1 font-semibold">Mot de passe *</label>
      <input pInputText formControlName="password" class="w-full" />
    </div>
    <div class="field mb-3">
      <label for="codeCourtier" class="block mb-1 font-semibold">Code courtier</label>
      <input pInputText formControlName="codeCourtier" class="w-full" />
    </div>
    <div class="flex justify-content-end gap-2 mt-4">
      <p-button label="Annuler" severity="secondary" (onClick)="showAddDialog = false"></p-button>
      <p-button label="Créer" type="submit" [disabled]="!addForm.valid" severity="success"></p-button>
    </div>
  </form>
</p-dialog>

<!-- Dialog Edition -->
<p-dialog *ngIf="isAdmin" header="Modifier le credential" [(visible)]="showEditDialog" [modal]="true"
          [style]="{width: '500px'}" [closable]="true">
  <div *ngIf="editingCredential" class="mb-3">
    <p-tag [value]="editingCredential.assureurDisplayName" [severity]="getAssureurSeverity(editingCredential.assureurName)"></p-tag>
    <span class="ml-2 text-500">pour {{ editingCredential.userName }}</span>
  </div>
  <form [formGroup]="editForm" (ngSubmit)="onUpdate()">
    <div class="field mb-3">
      <label class="block mb-1 font-semibold">Login *</label>
      <input pInputText formControlName="login" class="w-full" />
    </div>
    <div class="field mb-3">
      <label class="block mb-1 font-semibold">Mot de passe *</label>
      <input pInputText formControlName="password" class="w-full" />
    </div>
    <div class="field mb-3">
      <label class="block mb-1 font-semibold">Code courtier</label>
      <input pInputText formControlName="codeCourtier" class="w-full" />
    </div>
    <div class="flex justify-content-end gap-2 mt-4">
      <p-button label="Annuler" severity="secondary" (onClick)="showEditDialog = false"></p-button>
      <p-button label="Enregistrer" type="submit" [disabled]="!editForm.valid"></p-button>
    </div>
  </form>
</p-dialog>
